import { pluralize } from 'common/utils/utils';
import { StyledOrgsCounter } from '../../MonitoringRulesForm.style';
import InputRegex from '../InputRegex';
import { StyledOrgDetectionRegex } from './OrgDetectionRegex.style';
import useRegexOptionsCounter from './useRegexOptionsCounter';

const OrgDetectionRegex = ({ value, onChange, disabled, githubOrgs }) => {
  const [regexCounter, isLoading] = useRegexOptionsCounter({
    value,
    options: githubOrgs.options
  });

  return (
    <StyledOrgDetectionRegex>
      <InputRegex
        inputType={'organization'}
        value={value}
        onChange={onChange}
        disabled={disabled}
      />
      {!disabled && (
        <StyledOrgsCounter>
          {isLoading
            ? 'calculating...'
            : `${pluralize(
                regexCounter,
                'organization'
              )} currently match this regex`}
        </StyledOrgsCounter>
      )}
    </StyledOrgDetectionRegex>
  );
};

export default OrgDetectionRegex;
